import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero-clean-layout" id="hero">
            <div className="hero-image-container">
                <img
                    src="/images/hero-banner.jpg"
                    alt="Embrace Beauty Clinic"
                    className="hero-fullscreen-img"
                />
                
                <div className="hero-overlay-left">
                    <div className="hero-overlay-announcement">
                        <div className="card-logos-container">
                            <img
                                src="/assets/Embracelogo.png"
                                alt="Embrace Beauty Clinic"
                                className="card-logo"
                            />
                            <span className="card-logo-divider"></span>
                            <img
                                src="https://cdn.prod.website-files.com/681bf1d6f7dea459fe255c59/68252146834983973a92051f_cherry-logo-primary.svg"
                                alt="Cherry Payment Plans"

                                className="card-logo cherry-logo"
                            />
                        </div>
                        <p className="cherry-text">
                            We are now offering payment plans through Cherry 🍒 If you're interested, please apply before your appointment by using this link:
                        </p>
                        <a href="https://pay.withcherry.com/embrace-beauty-aesthetics" target="_blank" rel="noreferrer" className="cherry-btn">
                            Pay with Cherry
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
